import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from "@angular/common";
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '../../../environments/environment'
import * as CryptoJS from 'crypto-js';
import {Md5} from 'ts-md5/dist/md5';
import { Router } from '@angular/router';
import { BroadcastService } from './broadcast.service';
import { Message } from 'src/app/message';
declare var webengage: any;



@Injectable({
  providedIn: 'root'
})
export class CommonService {
  contentHeight: number;  
  error_message: any;
  url: any;
  urlArray: any = [];
  imageUrl: string = "";
  moreUrl: string = "";
  allUrl: string;
  private dom: Document;
  encrypted: any = "";
  decrypted: string;

  request: string;
  responce: string;
  new_play_url: string;
  obj: any; 
  // $: any;

  constructor(
    private router: Router,
    private http: HttpClient,
    @Inject(DOCUMENT) dom: Document,
    private broadcastService: BroadcastService,
  ) {
    this.dom = dom;
    this.handleError = this.handleError.bind(this);
  }
  pageHeight(): number {   
    let window_height = window.innerHeight;
    let x = $('.header').outerHeight() + $('.footer').outerHeight();
    this.contentHeight = window_height - x;
    return this.contentHeight;
  }

  setOtvUserLocalStorage(user: {}) {
    // console.log(user);
    if(window.localStorage){
      window.localStorage.setItem('otv_user_id', user['user_id']);
      // window.localStorage.setItem('otv_user_id', environment.userSession);
      window.localStorage.setItem('otv_user_name', user['user_name']);
      window.localStorage.setItem('otv_user_analytic_id', user['user_analy_id']);
      // window.localStorage.setItem('otv_user_login_id', user['user_login_id']);
      window.localStorage.setItem('otv_user_login_type', user['user_login_type']);
      window.localStorage.setItem('user_signin_id', user['user_signin_id']);
      window.localStorage.setItem('is_subscribed', user['user_subscribed']);
console.log('========== WebEngage Login ==========');
console.log('User ID:', user['user_analy_id']);
       webengage.user.login(user['user_analy_id']);
       webengage.user.setAttribute('we_first_name', user['user_name']);
    }
  }
  getOtvUserLocalStorage() {
    if(window.localStorage){
      window.localStorage.getItem('otv_user_id');
      window.localStorage.getItem('otv_user_name');
      window.localStorage.getItem('otv_user_analytic_id');
      // window.localStorage.getItem('otv_user_login_id');
      window.localStorage.getItem('otv_user_login_type');
    }
  }
  removeOtvUserLocalStorage() {
    if(window.localStorage){
    window.localStorage.removeItem('gdprText')
    window.localStorage.removeItem('otv_user_id');
    window.localStorage.removeItem('otv_user_name');
    window.localStorage.removeItem('otv_user_analytic_id');
    window.localStorage.removeItem('otv_user_login_id');
    window.localStorage.removeItem('otv_user_login_type');
    window.localStorage.removeItem('is_subscribed');
    window.localStorage.removeItem('favouritesList');
    window.localStorage.removeItem('catalogObj');
    window.localStorage.removeItem('selectedPlan');
    window.localStorage.removeItem('watchlist');
    window.localStorage.removeItem('continueWatchItems');
    window.localStorage.removeItem('retryToast');
    window.localStorage.removeItem('user_signin_id');
    window.localStorage.removeItem('isDetailspage');
    window.localStorage.removeItem('userType');
    window.localStorage.removeItem('isZingPlayUser');
    }
    webengage.user.logout();
  }
  
  getItemURL(i: any) {
    try {
      const catalogSlug =
        i?.['catalog_object']?.['friendly_id'] ||
        i?.['catalog_name'] ||
        i?.['catalog_id'] ||
        '';
      if (i['friendly_id'] == 'sur-sangram') {
        this.url = '/sursangram';
      } else if (i['theme'] == 'event') {
        this.url = catalogSlug + '/' + i['friendly_id'];
      } else if (i['theme'] == 'show_episode' || i['theme'] == 'episode') {
        const showSlug =
          i?.['show_object']?.['friendly_id'] || i?.['show_name'] || '';
        this.url =
          '/' + catalogSlug + '/' + showSlug + '/' + i['friendly_id'];
      } else if (i['theme'] == 'live' || i['theme'] == 'livetv') {
        this.url =
          '/' + (catalogSlug || 'all-channels') + '/' + i['friendly_id'];
      } else {
        this.url = '/' + catalogSlug + '/' + i['friendly_id'];
      }
      return this.url;
    } catch (e) {
      this.url = i?.['friendly_id'] ? '/' + i['friendly_id'] : '/';
      return this.url;
    }
  }

  getImageUrl(i: any, layout_type: string) {
    console.log("layout_type"+layout_type);
    this.imageUrl = "";
    if(layout_type == "t_16_9_banner" ) {
      this.imageUrl = i["thumbnails"] && i["thumbnails"]["xl_image_16_7"] ? i["thumbnails"]["xl_image_16_7"]["url"] : ".https://hls.tarangplus.in/default_images/xl_image_16_5_1920-600.jpg";
    }
    else if(layout_type == "t_2_3_movie_static" || layout_type == "movies" 
      || layout_type == "t_2_3_big_meta" || layout_type == "t_2_3_numeric" || 
      layout_type == "t_2_3_without_meta" || layout_type == "t_2_3_without_meta_single_show" 
      || layout_type == "t_2_3_movie") {
      this.imageUrl = i["thumbnails"] && i["thumbnails"]["xl_image_2_3"] ? i["thumbnails"]["xl_image_2_3"]["url"] : ".https://hls.tarangplus.in/default_images/xl_image_2_3_1000-1500.jpeg"; 
    }
    else if(layout_type == "t_16_9_big" || layout_type == "t_16_9_epg" || layout_type == "t_1_1_play" || layout_type == "videos" ||  layout_type == "t_16_9_livebanner" || layout_type == "t_16_9_big_without_meta" || layout_type == "t_16_9_big_meta" || layout_type == "t_16_9_without_meta" || layout_type == "t_16_9_without_meta_carousel" || layout_type == "t_16_5_subscribe" || layout_type == "t_16_9_banner_list") {
      if(i["thumbnails"] && i["thumbnails"].hasOwnProperty("medium_16_9")) {
        this.imageUrl = i["thumbnails"]["medium_16_9"] ? i["thumbnails"]["medium_16_9"]["url"] : "https://hls.tarangplus.in/default_images/xl_image_16_9_1920-1080.jpeg"; 
      }  else {
        this.imageUrl = "https://hls.tarangplus.in/default_images/xl_image_16_9_1920-1080.jpeg";
      }    
    }
    else if(layout_type == "t_16_9_small"  || layout_type == "t_16_9_small_meta" || layout_type == "video" || layout_type == "shows") {
      if(i["thumbnails"] && i["thumbnails"].hasOwnProperty("small_16_9")) {
        this.imageUrl = i["thumbnails"]["medium_16_9"] ? i["thumbnails"]["medium_16_9"]["url"] : "https://hls.tarangplus.in/default_images/xl_image_16_9_1920-1080.jpeg";
      } else {
        this.imageUrl = "https://hls.tarangplus.in/default_images/xl_image_16_9_1920-1080.jpeg";
      }
    }
    else if(layout_type == "t_1_1_plain") {
      if(i["thumbnails"] && i["thumbnails"].hasOwnProperty("xl_image_1_1")) {
        this.imageUrl = i["thumbnails"]["xl_image_1_1"]["url"]; 	
      } else {
        this.imageUrl = "./assets/tarangplus/placeholder_1x1.svg";
      }   
    }
    else if(layout_type == "t_comb_16_9_list" || layout_type == "t_16_9_big_meta" || layout_type == "t_16_9_right_meta") {
      if(i["thumbnails"] && i["thumbnails"].hasOwnProperty("large_16_9")) {
        this.imageUrl = i["thumbnails"]["xl_image_16_9"]["url"];
      } else {
        this.imageUrl = "https://hls.tarangplus.in/default_images/xl_image_16_9_1920-1080.jpeg";
      }    
    }
    else if(layout_type == "t_comb_1_1_image") {
      if(i["thumbnails"] && i["thumbnails"].hasOwnProperty("small_16_9")) {
        this.imageUrl = i["thumbnails"]["small_16_9"]["url"];
      } else {
        this.imageUrl = "https://hls.tarangplus.in/default_images/xl_image_16_9_1920-1080.jpeg";
      }   
    }
    else if(layout_type == "t_1_1_album" || layout_type == "t_1_1_album_meta") {    
      this.imageUrl = i["thumbnails"] ? i["thumbnails"]["medium_1_1"]["url"] : './assets/tarangplus/placeholder_1x1.svg';      
     } 
     //else if(layout_type == ){

    // }
    console.log("imageUrl"+this.imageUrl);
    return this.imageUrl
  }

  getListUrl(url: string, lang) {
    this.moreUrl = url;
    // if(lang && lang != "en") {
    //   this.moreUrl = this.moreUrl+"?lang="+lang;
    // } 
    return this.moreUrl;
  }
  getListAllUrl(url: string, lang: string) {
    this.allUrl = url;
  //   if(lang && lang != "en") {
  //     this.allUrl = "/"+this.allUrl+"/all?lang="+lang;
  // }
  //   else {
      this.allUrl = "/"+this.allUrl+"/all";
    // }
    return this.allUrl;
  }
  
  getPlayUrlKey(response: any) {
    //let smarturl = response['preview_url'] ? response['preview_url'] : response['preview']['preview_url'];
    let smarturl, url = '';;
    var smart_url_key = "ywVXaTzycwZ8agEs3ujx";
    var serv_id = "1"; 
    
    
    if(response['drm_protected'] === 'no'){
      smarturl = response['adaptive_urls']['hd']['hls'][0]['playback_url'];
       url = smarturl + "?service_id="+serv_id+"&protocol=hls&play_url=yes"; 
    } else {
      smarturl = response['adaptive_urls']['hd']['dash'][0]['playback_url'];
      url = smarturl + "?service_id="+serv_id+"&protocol=dash&play_url=yes";
    }
    
    var base_url = url+"&us=";
    
    const md5 = new Md5();
    var signature = md5.appendStr(smart_url_key+base_url).end()

    var signed_url =  base_url+signature;
    return signed_url;
  }

  getPlayBackUrl(signed_url: string): Observable<any> {
    if(signed_url){
      return this.http.get<any>(signed_url)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
    }
  }

  encryptPlayUrl(url: string): string {
    var new_url = ""
    let _key =  CryptoJS.AES.random_key;
    let _iv = CryptoJS.enc.Utf8.parse(url);
    var e_key = '';
    var a11 =  CryptoJS.AES.encrypt(_key).toString();
    var encrypted = CryptoJS.AES.update(url) + CryptoJS.AES.final
    new_url = CryptoJS.AES.encrypt(encrypted).gsub(/\n/, '');
    // console.log("new_url"+new_url+"a11"+a11);
    return new_url;
  }
  
  getMenuList(region: string) {
    let lang = "";
    //http://13.233.16.182/catalog_lists/catalog-tabs?region=IN&item_language=od&auth_token=3zZmzoHg8z6SM3wpDoyw
    return this.http.get<any>(environment.apiURL+"catalog_lists/catalog-tabs.gzip?region="+region+"&item_language="+lang+"&auth_token="+environment.authtoken)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  getOpenGraphTags(region: string){
    //https://stagingapi.tarangplus.com/catalogs/message/items/open-graph-tags?current_version=123&auth_token=jqeGWxRKK7FK5zEk3xCM&region=IN&item_language=en
    return this.http.get<any>(environment.apiURL+"catalogs/message/items/open-graph-tags.gzip?current_version=123&auth_token="+environment.authtoken+'&region='+region+'&item_language=en')
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  copyVideoURL(id: string) {
    var element = null; // Should be <textarea> or <input>
    var st: boolean = false;
    try {
      element = this.dom.getElementById(id);
      element.select();
      this.dom.execCommand("copy");
      st = true;
    }    
    finally {
      this.dom.getSelection().removeAllRanges;
    }
    window.getSelection().selectAllChildren(document.getElementById(id));
    document.execCommand("Copy"); 
    return st;
  }
  
  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    console.log(error);
   
    if (error.error instanceof ErrorEvent) {
       console.log('client-side error')
      errorMessage = `Error: ${error.error.message}`;
    } else {
      console.log('server-side error');
      console.log(error);
      const body = error.error;
      const nested = body?.error;
      if (nested && typeof nested === 'object') {
        this.error_message = {
          server_error_code: nested.code ?? body.code ?? error.status,
          server_error_messsage:
            nested.message || nested.error || body.message || '',
        };
      } else if (typeof nested === 'string') {
        this.error_message = {
          server_error_code: body.code ?? error.status,
          server_error_messsage: nested,
        };
      } else if (typeof body?.message === 'string') {
        this.error_message = {
          server_error_code: body.code ?? error.status,
          server_error_messsage: body.message,
        };
      } else {
        this.error_message = {
          server_error_code: error.status,
          server_error_messsage:
            error.status === 0
              ? 'Please check your internet connection'
              : error.message,
        };
      }
      
      //errorMessage = `server_error message: ${error.error.error.message}+Error Code: ${error.status}+Message: ${error.message}`;
      errorMessage = this.error_message;
      const code = this.error_message?.server_error_code;
      const msg = this.error_message?.server_error_messsage || '';
      if (
        (code === '1016' || code === 1016 || msg === 'Invalid User Id') &&
        window.localStorage?.getItem('otv_user_id')
      ) {
        this.broadcastService.dispatch(new Message('sessionExpired', null));
      }
    }   
    return throwError(errorMessage);
  }

  loadScriptDynamically(url: string) {
    let body = <HTMLDivElement> document.body;
    let script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  } 

  //change the api endpoint as required 
  getUpcomingData(parentControl: boolean = false) {
    let url = environment.apiURL + 'catalog_lists/upcoming.gzip?auth_token=' + environment.authtoken;
    if (parentControl) {
      url += '&parental_control=true';
    }
    return this.http
      .get<any>(url)
      .pipe(retry(1), catchError(this.handleError));
  } 


   reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
}
